<template>
  <div id="export-report-modal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog" style="max-width: 400px">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">EXPORT</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12" style="overflow: hidden;">
              <vue-spinner v-if="loading"></vue-spinner>

              <template v-else-if="!generating">
                <h5 class="margin-bottom-20">XLS EXPORT OPTIONS</h5>
                <label class="mt-checkbox mt-checkbox-outline">
                  <input type="checkbox" v-model="xlsExport.results"/>
                  <span></span>Export Results
                </label>
                <br/>
                <label class="mt-checkbox mt-checkbox-outline" :class="{'label__disabled' : !hasSummary}">
                  <input :disabled="!hasSummary" type="checkbox" v-model="xlsExport.summary"/>
                  <span></span>Export Summary
                </label>
                <br/>
                <button class="btn green" :disabled="Object.values(xlsExport).every(item => !item)" @click="exportXls">Export XLS</button>
                <hr/>

                <template v-if="false">
                  <h5 class="margin-bottom-20">PDF EXPORT OPTIONS</h5>
                  <label class="mt-checkbox mt-checkbox-outline">
                    <input type="checkbox" v-model="pdfExport.results"/>
                    <span></span>Export Results
                  </label>
                  <br/>
                  <label class="mt-checkbox mt-checkbox-outline">
                    <input type="checkbox" v-model="pdfExport.summary"/>
                    <span></span>Export Summary
                  </label>
                  <br/>
                  <label class="mt-checkbox mt-checkbox-outline">
                    <input type="checkbox" v-model="pdfExport.charts"/>
                    <span></span>Export Charts
                  </label>
                  <br/>
                  <button class="btn green" :disabled="Object.values(pdfExport).every(item => !item)" @click="exportPdf">Export PDF</button>
                  <hr/>
                </template>

                <h5 class="margin-bottom-20">CSV EXPORT OPTIONS</h5>
                <label class="mt-checkbox mt-checkbox-outline">
                  <input type="checkbox" v-model="csvExport.results"/>
                  <span></span>Export Results
                </label>
                <br/>
                <button class="btn green" :disabled="Object.values(csvExport).every(item => !item)" @click="exportCsv">Export CSV</button>
                <hr/>
                <button class="btn default pull-right" @click="closeModal()">Cancel</button>
              </template>

              <template v-if="generating">
                <div class="mb-2">Generating {{fileType.toUpperCase()}} file, please wait...</div>
                <div class="progress progress-custom">
                  <div class="progress-bar" role="progressbar" v-bind:style="{width: progressBarPercent + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{progressBarPercent}}%</div>
                </div>

                <vue-spinner v-if="exportData.url === ''"></vue-spinner>

                <a v-else class="btn green" :disabled="exportData.url == ''" :href="exportData.url !== '' ? exportData.url : '#'">
                  <i class="icon-cloud-download"></i>&nbsp; Download
                </a>
              </template>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {HTTP, URL} from '@/http-common';
  import Spinner from '@/components/Spinner';

  export default {
    components: {
      'vue-spinner': Spinner
    },
    name: 'ExportReportFile',
    props: ['reportId', 'resultTotalRows'],
    data() {
      return {
        totalRows: 0,
        fileType: '',
        generating: false,
        hasSummary: false,
        exportData: {
          'url': '',
          'chunk': 0,
          'rowsInChunk': 20000
        },
        xlsExport: {
          results: false,
          summary: false,
          charts: false
        },
        pdfExport: {
          results: false,
          summary: false,
          charts: false
        },
        csvExport: {
          results: false
        },
        loading: false
      }
    },
    computed: {
      progressBarPercent() {
        let current_chunk = this.exportData.chunk;
        // let max_chunk = Math.ceil(this.totalRows / this.exportData.rowsInChunk);
        let current_percent = Math.round((current_chunk * this.exportData.rowsInChunk) * 100 / this.totalRows);

        if (this.exportData.url !== '') {
          return 100;
        }

        if (current_chunk === 0) {
          return 0;
        }

        return current_percent;
      }
    },
    mounted() {
      $('#export-report-modal').modal('show');

      this.loading = true;

      HTTP.get('report-summary/report-has-summary/' + this.reportId).then(response => {
        this.hasSummary = !!response.data.data.has_summary;
      }).finally(() => {
        this.loading = false;
      })

      $('#export-report-modal').on('hide.bs.modal', () => {
        this.$emit('display', false);
      });
    },

    methods: {
      closeModal() {
        $('#export-report-modal').modal('hide');
      },
      exportXls() {
        this.fileType = 'xlsx';
        return this.exportFile();
      },
      exportPdf() {

      },
      exportCsv() {
        this.fileType = 'csv';
        return this.exportFile();
      },
      exportFile() {
        this.generating = true;
        this.exportData = {
          'url': '',
          'chunk': 0,
          'rowsInChunk': 100
        };

        $('#export-report-file-modal').modal('show');

        HTTP.post('reports/export', {
          'type': this.fileType,
          'report_id': this.reportId,
          'chunk': 0,
          'pdf_export': this.pdfExport,
          'xls_export': this.xlsExport,
          'csv_export': this.csvExport
        })
          .then(response => {
            if (response.data.status === 'success') {
              let url;
              if (response.data.data.url !== '') {
                url = URL + '/' + response.data.data.url + '?token=' + localStorage.getItem('id_token');
              } else {
                url = '';
              }

              this.exportData = {
                'chunk': response.data.data.next_chunk,
                'rowsInChunk': response.data.data.rows_in_chunk,
                'url': url,
              };

              if (this.exportData.chunk > 0) {
                this.exportData.inProgress = true;
                this.exportFileNextChunk();
              }
            }
          })
          .catch(err => {
            console.log(err)
          });
      },

      exportFileNextChunk() {
        if (!this.exportData.inProgress) {
          return;
        }

        HTTP.post('reports/export', {
          'type': this.fileType,
          'report_id': this.reportId,
          'chunk': this.exportData.chunk,
          'pdf_export': this.pdfExport,
          'xls_export': this.xlsExport,
          'csv_export': this.csvExport
        }).then(response => {

          if (response.data.data.next_chunk === 0) {
            this.exportData = {
              'url': URL + '/' + response.data.data.url + '?token=' + localStorage.getItem('id_token'),
              'chunk': 0,
              'rowsInChunk': 0,
              'inProgress': false
            };
            return;
          }

          this.exportData = {
            'url': '',
            'chunk': response.data.data.next_chunk,
            'rowsInChunk': response.data.data.rows_in_chunk,
            'inProgress': true
          };

          this.exportFileNextChunk();

        }).catch(err => {
          console.log(err)
        });
      },
    },
  }
</script>

<style scoped>
  .progress-bar {
    background-color: #d09f23;
  }

  .progress-custom {
    padding: 0;
    margin-top: 20px;
    overflow: hidden;
  }

  .label__disabled {
    color: #aaa;
  }
</style>



// WEBPACK FOOTER //
// ExportModal.vue?1384f966